import { render, staticRenderFns } from "./DeclarationApprovalStep.vue?vue&type=template&id=45b5abb3&"
import script from "./DeclarationApprovalStep.vue?vue&type=script&lang=js&"
export * from "./DeclarationApprovalStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports